export const collectModuleExtensionExports = (modules, exportName) => Object.values(modules)
    .flatMap(module => Array.isArray(module?.[exportName]) ? module[exportName] : [])
    .filter(Boolean);